import store from 'app/store';
import { FuseLoadable } from '@fuse';

const Index = {
    auth: ['admin', 'sub-admin'],
    routes: [
        {
            path: '/pooling',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./PoolingApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
